import { render, staticRenderFns } from "./QuanLyChuoiCungUng.vue?vue&type=template&id=6e16df44"
import script from "./QuanLyChuoiCungUng.vue?vue&type=script&lang=js"
export * from "./QuanLyChuoiCungUng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports